 <template>
  <div class="inline">
    <a href="#" class="link-green" @click.prevent="show">
      <slot />
    </a>
    <modal width="65%"  height="90%" :name="name" class="relative">
        <button type="button" class="bg-red-500 hover:bg-red-600 rounded absolute right-0 top-0 mt-2 mr-2" @click="hide">
            <div class="text-white text-6xl p-3">
                <svg class="w-3 h-3 fill-current" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 348.333 348.334" style="enable-background:new 0 0 348.333 348.334;" xml:space="preserve">
<g><path d="M336.559,68.611L231.016,174.165l105.543,105.549c15.699,15.705,15.699,41.145,0,56.85
c-7.844,7.844-18.128,11.769-28.407,11.769c-10.296,0-20.581-3.919-28.419-11.769L174.167,231.003L68.609,336.563
c-7.843,7.844-18.128,11.769-28.416,11.769c-10.285,0-20.563-3.919-28.413-11.769c-15.699-15.698-15.699-41.139,0-56.85
l105.54-105.549L11.774,68.611c-15.699-15.699-15.699-41.145,0-56.844c15.696-15.687,41.127-15.687,56.829,0l105.563,105.554
L279.721,11.767c15.705-15.687,41.139-15.687,56.832,0C352.258,27.466,352.258,52.912,336.559,68.611z"/></g>
</svg>
            </div>
        </button>
      <div class="px-6 py-8 overflow-auto h-full w-full ">
        <h1 class="title title-red md:text-3xl">TR & Gift Box Chocolate Piece Choices</h1>
        <p class="mb-6">
          Highlight your industry, promote a theme or celebrate a holiday with one of the shapes below. Select up to two designs for the TR or Gift Box Series at no aditional cost.
        </p>

        <p class="mb-6">
          To create a new custom shape, call or email us for details.
        </p>

        <table class="table-fixed w-full text-xs mx-auto" style="width: 800px;">
          <tr>
            <td><img src="/images/stock-pieces/tr-box/1.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/2.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/3.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/4.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/5.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/6.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/7.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/8.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/9.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/10.jpg"></td>
          </tr>
          <tr>
            <td>1 - Airplane</td>
            <td>2 - Bathtub</td>
            <td>3 - Bed</td>
            <td>4 - Boot</td>
            <td>5 - Bull</td>
            <td>6 - Bear</td>
            <td>7 - Building</td>
            <td>8 - Caduceus</td>
            <td>9 - Car</td>
            <td>10 - Cell Phone</td>
          </tr>
          <tr>
            <td><img src="/images/stock-pieces/tr-box/11.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/12.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/13.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/14.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/15.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/16.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/17.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/18.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/19.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/20.jpg"></td>
          </tr>
          <tr>
            <td>11 - Cement Mixer</td>
            <td>12 - Computer</td>
            <td>13 - Computer Mouse</td>
            <td>14 - Cruise Ship</td>
            <td>15 - Dollar Sign</td>
            <td>16 - Dump Truck</td>
            <td>17 - Globe</td>
            <td>18 - Hammer</td>
            <td>19 - Happy Holidays</td>
            <td>20 - Hard Hat</td>
          </tr>
          <tr>
            <td><img src="/images/stock-pieces/tr-box/21.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/22.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/23.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/24.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/25.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/26.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/27.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/28.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/29.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/30.jpg"></td>
          </tr>
          <tr>
            <td>21 - Heart</td>
            <td>22 - House</td>
            <td>23 - Key</td>
            <td>24 - Lightbulb</td>
            <td>25 - Mortar &amp; Pestle</td>
            <td>26 - Music Note</td>
            <td>27 - Puzzle Piece</td>
            <td>28 - Saw</td>
            <td>29 - Scales of Justice</td>
            <td>30 - Screwdriver</td>
          </tr>
          <tr>
            <td><img src="/images/stock-pieces/tr-box/31.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/32.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/33.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/34.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/35.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/36.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/37.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/38.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/39.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/30.jpg"></td>
          </tr>
          <tr>
            <td>31 - Shoe</td>
            <td>32 - Shovel</td>
            <td>33 - Slot Machine</td>
            <td>34 - Star</td>
            <td>35 - Telephone</td>
            <td>36 - Television</td>
            <td>37 - Thank You</td>
            <td>38 - Toilet</td>
            <td>39 - Tooth</td>
            <td>40 - Tractor</td>
          </tr>
          <tr>
            <td><img src="/images/stock-pieces/tr-box/41.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/42.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/43.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/44.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/45.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/46.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/47.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/48.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/49.jpg"></td>
            <td><img src="/images/stock-pieces/tr-box/50.jpg"></td>
          </tr>
          <tr>
            <td>41 - Truck</td>
            <td>42 - Van</td>
            <td>43 - Wrench</td>
            <td>44 - Stock Chocolate</td>
            <td>45 - Ornament</td>
            <td>46 - Snowflake</td>
            <td>47 - Snowman</td>
            <td>48 - Easter Bunny</td>
            <td>49 - Easter Egg</td>
            <td>50 - Flag</td>
          </tr>
        </table>

      </div>
    </modal>

  </div>
 </template>

 <script>
   export default {
       // name: 'stock-themed-pieces',
     props: ['value'],

     computed: {
        name () {
          return `modal-${this.value}`
        }
     },

     methods: {
       show () {
         this.$modal.show(this.name);
       },
       hide () {
         this.$modal.hide(this.name);
       }
     }
   }
 </script>
